









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { CurrencyRate, UserModule } from "@/store/modules/User";

@Component
export default class CurrencyComponent extends Vue {
    @Prop()
    public value!: number;

    @Prop()
    public country!: string;

    @Prop({ type: Number })
    public systemId!: number;

    @Prop(Number)
    public maximumFractionDigits!: number;

    convertedRate = false;

    get formattedValue() {
        const currency = this.getCurrency();
        this.convertedRate = currency.rate?.currencyRate !== undefined;
        const value = currency.rate?.currencyRate ? this.value / currency.rate.currencyRate : this.value;

        return this.$format.currency(value, currency.country, this.shouldConvert ? UserModule.settings.currency : undefined, this.maximumFractionDigits);
    }

    getCurrency(): { rate: CurrencyRate | undefined; country: string } {
        let country = this.country;

        if (!this.country) {
            const findSystem = UserModule.systems.find(system => system.systemId === this.systemId);

            if (!findSystem) {
                throw new Error(`Could not find system with ID '${this.systemId}' on user's systems object`);
            }

            country = findSystem.country.countryName;
        }
        const systemCurrency = this.$format.currencyName(country);

        const rate = UserModule.currencyRates.find(i => i.currencyCodeFrom === systemCurrency && i.currencyCodeTo === UserModule.settings.currency);

        return { rate, country };
    }

    get formattedLocalValue() {
        if (this.country) {
            return this.$format.currency(this.value, this.country);
        }

        return this.$format.currencyBySystem(this.value, this.systemId);
    }

    get localCurrency() {
        const currency = this.getCurrency();

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.formattedLocalValue + " ⇄ "+ this.$format.date(currency.rate?.currencyDate!);
    }

    get shouldConvert() {
        return UserModule.settings.currency !== "LOCAL";
    }
}
